/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryPlus: {
  name: 'battery-plus';
  data: string;
} = {
  name: 'battery-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 5A1.5 1.5 0 0 1 2 3.5h10A1.5 1.5 0 0 1 13.5 5v6a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 11V5ZM2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H2ZM7.5 6a.5.5 0 0 0-1 0v1.5H5a.5.5 0 0 0 0 1h1.5V10a.5.5 0 0 0 1 0V8.5H9a.5.5 0 0 0 0-1H7.5V6Zm8 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6Z" fill="currentColor"/></svg>`,
};
